// extracted by mini-css-extract-plugin
module.exports = {"focalImageContainer":"FocalImageWrapper_focalImageContainer__1AauV"};